import * as Yup from 'yup';

import AllInclusiveRoundedIcon from '@mui/icons-material/AllInclusiveRounded';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ScheduleIcon from '@mui/icons-material/Schedule';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import EventBusyRoundedIcon from '@mui/icons-material/EventBusyRounded';
import PersonOffRoundedIcon from '@mui/icons-material/PersonOffRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import HourglassBottomRoundedIcon from '@mui/icons-material/HourglassBottomRounded';
import HowToRegRoundedIcon from '@mui/icons-material/HowToRegRounded';

import { formatGenericDateTime, formatCurrency, formatGenericDate, formatGenericTime } from '../../utils/util';

import { displayLabelCustomer } from '../../utils/displayLabels';

import { lighten, darken } from '@mui/material';

import SimpleChip from '../../utils/utilities/SimpleChip';

const headers = [
  {
    label: "Event",
    id: "title",
    render: (row) => {
      let bgColor = lighten(row?.block_color || '#000', 0.7);
      let color = darken(row?.block_color || '#000', 0.6);
      return (
        <SimpleChip label={row.title} color={color} bgColor={bgColor} />
      )
    }
  },
  {
    label: "Customer",
    id: "customer",
     render: (row) => {
      let option = {
        full_name: row.customer,
        mobile_phone: row.customer_phone,
      }
      return displayLabelCustomer(option, "short")
    }
  },
  {
    label: "Status",
    id: "status",
    multi: true,
    values: [{value: "scheduled", label: "Scheduled", status: "primary"}, {value: "cancelled", label: "Cancelled", status: "error"}, {value: "no_show", label: "No Show", status: "error"}, {value: "in_progress", label: "In Progress", status: "warning"}, {value: "completed", label: "Show", status: "success"}]
  },
  {
    label: "Stylist",
    id: "stylist"
  },
  {
    label: "Date",
    id: "start_time",
    render: row => formatGenericDateTime(row.start_time),
  },
  {
    label: "Price",
    id: "invoice_total",
    render: row => row.invoice_total || row.invoice_total === 0 ? formatCurrency(row.invoice_total) : formatCurrency(row.total),
  },
  // {
  //   label: "Time",
  //   id: "start_time",
  //   render: row => formatGenericTime(row.start_time),
  // },
  {
    label: "Balance",
    id: "invoice_balance",
    render: row => row.invoice_balance || row.invoice_balance === 0 ? formatCurrency(row.invoice_balance) : "-",
  },
];

const customHeaders = [
  {
    label: "Order ID",
    id: "wig_order_num"
  },
  {
    label: "Customer",
    id: "customer_name"
  },
  {
    label: "Appointment Date",
    id: "appointment_start_time",
    date: true
  },
  {
    label: "Wig ID",
    id: "wig_id",
  },
  {
    label: "Status",
    id: "status",
    multi: true,
    values: [{value: "pending", label: "Pending", status: "warning"}, {value: "cancelled", label: "Cancelled", status: "error"}, {value: "assigned", label: "Assigned", status: "success"}, {value: "fulfilled", label: "Fulfilled", status: "success"}]
  },
  {
    label: "Date Created",
    date: true,
    id: "created_at"
  }
];

const filters = [
  {
    id: "s.full_name",
    type: "autoMulti",
    label: "Stylist",
    url: '/stylists',
    fieldOptions: {
      fieldName: "full_name",
      displayField: "full_name"
    },
    prefetch: true
  },
  {
    id: "appointment_date",
    type: "date",
    label: "Date",
  },
  {
    id: "title",
    type: "autoMulti",
    label: "Service Type",
    url: '/services',
    fieldOptions: {
      fieldName: "name",
      displayField: "name"
    },
    prefetch: true
  }
]

const tabs = [
  {id: "scheduled", label: "Scheduled", Icon: PendingActionsRoundedIcon },
  {id: "completed", label: "Show", Icon: HowToRegRoundedIcon },
  {id: "no_show", label: "No Show", Icon: PersonOffRoundedIcon },
  {id: "cancelled", label: "Cancelled", Icon: EventBusyRoundedIcon },
  {id: "all", label: "All", Icon: AllInclusiveRoundedIcon },
]


export { headers, filters, tabs };